module.exports = __webpack_public_path__ + "static/media/bir-logo.f9a515aa.png";